<template>
  <CLink @click="onClick(plan)" class="plan-item" :class="{'active': plan.id===selected}">
    <div class="plan-item__default" v-if="isRecommended">
      <CIcon name="cipStars01" size="custom-size" width="20" height="20" class="mr-1"/>
      <translate>Recommended</translate>
    </div>
    <div class="d-flex justify-content-between">
      <h6 class="plan-item__title">
        <CIcon name="cipCube01" size="custom" :height="20" class="mr-1" style="vertical-align: sub"/>
        {{ plan.name }}</h6>
      <CIcon name="cipCircleCheckFill" size="custom-size" width="18" height="18" class="ml-2 text-primary"
             v-if="plan.id===selected"/>
      <CIcon name="cipCircle" size="custom-size" width="18" height="18" class="ml-2" v-else/>
    </div>
    <h4 class="plan-item__price">
      <template v-if="plan.is_promo">
        <span class="value">{{ plan.price|currency(currency) }}</span> /
        <translate content="public_plan.base">event</translate>
      </template>
      <template v-else>
        <span class="value">{{ plan.pica_fee_perc }}%</span>
        <span class="sub-value" v-translate>transaction fee</span>
        <div class="more" v-translate> Credit card processing included</div>
      </template>
    </h4>
    <div class="plan-item__for">
      <div v-html="getDescription(plan)"></div>
    </div>
  </CLink>
</template>
<script>
export default {
  name: "BasePlanItem",
  props: {
    plan: {
      type: Object,
      required: true
    },
    selected: {
      type: Number,
      default: null
    },
    currency: {
      type: String,
      required: true
    }
  },
  computed: {
    isRecommended() {
      return this.plan.recommended ?? this.plan.is_default;
    }
  },
  methods: {
    onClick(plan) {
      this.$emit('update:value', plan.id)
      this.$emit('input', plan)
    },
    getDescription(plan) {
      return this.$gettextInterpolate(
          'Up to <b> %{mediaIncluded} photos</b>, recommended for %{numParticipants} participants',
          {
            mediaIncluded: plan.media_included || 'N/A',
            numParticipants: plan.recommended_participants || 'N/A'
          }
      )
    },
  }
}
</script>


<style scoped>

</style>